// src/features/simulators/kiosk/components/KioskSimulator.tsx

import React, { useState, useCallback } from 'react';
import { useTranslate } from 'react-admin';
import { DesktopWindows as KioskIcon } from '@mui/icons-material';
import { SimulatorWizard } from '../../shared/components/SimulatorWizard';
import { useSimulatorWizard } from '../../shared/hooks/useSimulatorWizard';
import { KioskConfigForm } from './KioskConfigForm';
import { useKioskSimulation } from '../hooks/useKioskSimulation';
import { KeyDeliveryMethod, SectionCode } from '../../shared/types/journey.types';
import type { KioskConfigValues } from './KioskConfigForm';

export const KioskSimulator: React.FC = () => {
  const translate = useTranslate();
  const wizard = useSimulatorWizard({ deviceType: 'Kiosk', channel: 'Kiosk' });
  const { simulate } = useKioskSimulation();

  const [config, setConfig] = useState<KioskConfigValues>({
    journeyType: 'new_checkin',
    keyDeliveryMethod: KeyDeliveryMethod.RFID_CARD,
    sectionsToProcess: [SectionCode.S, SectionCode.I, SectionCode.F, SectionCode.U, SectionCode.P],
    reservationNumber: '',
    autoGenerateReservation: true,
  });

  const handleRun = useCallback(() => {
    wizard.runSimulation(async (client, addLog) => {
      return simulate(client, addLog, wizard.deviceId, wizard.hotelId, config);
    });
  }, [wizard, simulate, config]);

  return (
    <SimulatorWizard
      title={translate('resources.simulators.kiosk.title')}
      subtitle={translate('resources.simulators.kiosk.description')}
      icon={<KioskIcon />}
      wizard={wizard}
      deviceType="Kiosk"
      channel="Kiosk"
      configForm={
        <KioskConfigForm
          values={config}
          onChange={setConfig}
        />
      }
      onRun={handleRun}
    />
  );
};

export default KioskSimulator;
